import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(private readonly router: Router) {
  }


  ngOnInit(): void {
    sessionStorage.clear();
    localStorage.clear();
    void this.router.navigate(['/login']);
  }

}
